export default["__VITE_ASSET__ppIM5uwD__","__VITE_ASSET__5nIStl5B__"];